/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


export const styles:any[] = [''];
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL2FwcC9zcmMvYXBwL2NvbXBvbmVudHMvYWRtaW4vaGNhLWFkbWluL3NldHRpbmdzL2hjYS1zZXR0aW5ncy9oY2Etc2V0dGluZ3MuY29tcG9uZW50LnNjc3Muc2hpbS5uZ3N0eWxlLnRzIiwidmVyc2lvbiI6Mywic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsibmc6Ly8vYXBwL3NyYy9hcHAvY29tcG9uZW50cy9hZG1pbi9oY2EtYWRtaW4vc2V0dGluZ3MvaGNhLXNldHRpbmdzL2hjYS1zZXR0aW5ncy5jb21wb25lbnQuc2NzcyJdLCJzb3VyY2VzQ29udGVudCI6WyIgIl0sIm1hcHBpbmdzIjoiQUFBQTs7Ozs7Ozs7In0=



// WEBPACK FOOTER //
// ./src/$$_gendir/app/components/admin/hca-admin/settings/hca-settings/hca-settings.component.scss.shim.ngstyle.ts